<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow}"
        tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" v-show="isShow">
        <div class="modal-bg" @click="onModalClose"></div>
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="common-modal-close" data-dismiss="modal" aria-label="Close" @click="onModalClose">
                    <img class="common-modal-close" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg">
                </div>

                <div class="modal-body" v-if="!isNrp">
                    <p>通过“皇家加勒比国际游轮”中国大陆官方网站、微信小程序和电话预订适用航次，除了一次性支付订单全款外，还可以选择“订金人民币1000元/人起+尾款”的支付方式，具体要求如下：</p>
                    <p>1. 适用航次：中国大陆母港出发的所有航次，具体航次和舱房以预订当时的在售情况和实际库存为准。</p>
                    <p>2. 适用时间：在开航日60天(不含)前。部分航线因销售及库存等原因，可能提前关闭订金支付。</p>
                    <p>3. 预订后，可以先支付订金人民币1000元/人，享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为订金，尾款于预订航次开航45天（不含）前支付即可。</p>
                    <p>4. 如未在开航45天（不含）前支付尾款的，订单会被自动取消，已支付的订金将会按原付款渠道退回。</p>
                    <p>5. 预订时提交出行人信息，并至少保持一名出行人信息自提交之日起不变。</p>
                    <p>6. 本活动不可与订金膨胀活动、通兑活动等同享。</p>
                </div>
                <div class="modal-body" v-else>
                    <p>通过“皇家加勒比国际游轮”中国大陆官方网站、微信小程序和电话预订适用航次，除了一次性支付订单全款外，还可以选择“订金人民币1000元/人起+尾款”的支付方式，具体要求如下：</p>
                    <p>1. 适用航次：中国大陆母港出发的所有航次，具体航次和舱房以预订当时的在售情况和实际库存为准。</p>
                    <p>2. 适用时间：在开航日60天(不含)前。部分航线因销售及库存等原因，可能提前关闭订金支付。</p>
                    <p>3. 预订后，可以先支付订金人民币1000元/人，享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为订金，尾款于预订航次开航45天（不含）前支付即可。</p>
                    <p>4. 如未在开航45天（不含）前支付尾款的，订单会被自动取消，普通房型将收取1000元人民币/人作为取消费用；享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为取消费用（不包括港务税费）</p>
                    <p>5. 预订时提交出行人信息，并至少保持一名出行人信息自提交之日起不变。</p>
                    <p>6. 本活动不可与订金膨胀活动、通兑活动等同享。</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DepositPopup",
    props: {
        isShow: {
            type: Boolean
        },
        isNrp: {
            type: Boolean,
            default () {
                return false
            }
        }
    },
    data () {
        return {
            isShowModal: false
        }
    },
    methods: {
        onModalClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.$emit('onModalClose')
            }, 100)
        }
    },
    watch: {
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        }
    }
}
</script>

<style lang="less" scoped>
.modal-body {
    padding: 15px 30px 30px 30px;
}
.modal-dialog {
    top: 50px;

}

.modal {
    .common-modal-close {
        position: absolute;
        width: 28px;
        top: 3px;
        right: 5px;
        z-index: 2;
        cursor: pointer;
    }
}

.modal.active {
    display: block;
}

.modal-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
